export const COMPANY_FEATURE_KEY = 'company';

export const COMPANY_DISABLED = 'Disabled';
export const COMPANY_ENABLED = 'Enabled';

export const COMPANY_DETAILS_TAB = 'Details';
export const COMPANY_LOBS_TAB = "LOB's";
export const COMPANY_USERS_TAB = 'Users';

export const COMPANY_TEMPLATE_GENERIC = 'Generic';
export const COMPANY_TEMPLATE_ALLIANZ = 'Allianz';

export const CURRENT_PERIOD_ID = '-1';
export const CURRENT_PERIOD_LABEL = 'current';
